import { useQuery } from "@tanstack/react-query";
import { fetchAssets, fetchAssetById, fetchAssignmentHistory, fetchAssetCategorySummary } from "@/api/assets";
import { fetchMyAccess } from "@/api/assetRequests";
import { fetchTenantProfile } from "@/api/tenant";
import type { AssetQueryParams } from "@/types/asset";

export function useMyAccess() {
  return useQuery({
    queryKey: ["my-access"],
    queryFn: fetchMyAccess,
    staleTime: Infinity
  });
}

export function useTenantProfile(enabled = true) {
  return useQuery({
    queryKey: ["tenant"],
    queryFn: fetchTenantProfile,
    enabled,
    staleTime: 60_000
  });
}

export function useAssets(params: AssetQueryParams) {
  return useQuery({
    queryKey: ["assets", params],
    queryFn: () => fetchAssets(params),
    placeholderData: (prev) => prev
  });
}

export function useAsset(id: string | undefined) {
  return useQuery({
    queryKey: ["asset", id],
    queryFn: () => fetchAssetById(id as string),
    enabled: !!id
  });
}

export function useAssignmentHistory(assetId: string | undefined) {
  return useQuery({
    queryKey: ["assignment-history", assetId],
    queryFn: () => fetchAssignmentHistory(assetId as string),
    enabled: !!assetId
  });
}

export function useAssetCategorySummary(enabled = true) {
  return useQuery({
    queryKey: ["asset-category-summary"],
    queryFn: fetchAssetCategorySummary,
    enabled
  });
}
